<template>
    <transition>
        <timer v-show="active" ref="timer" />
    </transition>
</template>

<script>
import io from "socket.io-client";

import Timer from "@/components/custom/maddy/Timer";
export default {
    name: "TimerView",
    components: { Timer },
    data() {
        return {
            active: false,
            timeTotal: 0,
        };
    },
    methods: {
        start(seconds) {
            this.active = true;
            this.$refs.timer.timeLeft = seconds;
            this.$refs.timer.timeTotal = seconds;
            this.$refs.timer.start();
        },
        continue() {
            this.$refs.timer.start();
        },
        pause() {
            this.$refs.timer.pause();
        },
        add(seconds) {
            this.$refs.timer.addTime(seconds);
        },
        cancel() {
            this.active = false;
            this.$refs.timer.cancel();
        },
    },
    mounted() {
        let socketURL;

        if (process.env.NODE_ENV === "development") {
            socketURL = "localhost:8042";
        } else {
            socketURL = "https://merubot.madeleineink.com";
        }

        this.socket = io(socketURL, {
            transports: ["websocket", "xhr-pulling"],
        });

        this.socket.on("timer_started", data => {
            this.start(data);
        });

        this.socket.on("timer_paused", () => {
            this.pause();
        });

        this.socket.on("timer_continued", () => {
            this.continue();
        });

        this.socket.on("timer_cancelled", () => {
            this.cancel();
        });

        this.socket.on("timer_added", seconds => {
            this.add(seconds);
        });
    },
};
</script>

<style lang="scss" scoped></style>
